import React from 'react';
import logoIngenieria from '../../assets/logos/logo-ingenieria.png';
import logoUdeaflix from '../../assets/logos/logo-udeaflix.png';
import './styles.css';
import { Link } from 'react-router-dom';

export const Header = () => {
  return (
    <div id="Header">
      <div className="HeaderContainer">
        <Link className="HeaderItem" to="/">
          <img className="HeaderLogo" src={logoUdeaflix} alt="Logo UdeAflix" />
        </Link>
        <a
          className="HeaderItem"
          href="http://ingenieria.udea.edu.co/"
          target="_blank"
        >
          <img
            className="HeaderLogo filtroBlanco"
            src={logoIngenieria}
            alt="Logo universidad de antioquia"
          />
        </a>
      </div>
    </div>
  );
};
